export function NullErr(msg: string, cause?: Record<string, any>): never {
    let causeString = '';
    try {
        causeString = `Cause: ${JSON.stringify(cause)}`;
    } catch {}
    throw new Error(`${msg} ${causeString}`);
}
